import {store} from '../redux/store';
import {DefaultTheme} from 'styled-components';

export const getFontFamily = (theme: DefaultTheme): string => {
  const {languageCode} = store.getState().lang || {};
  return theme.fonts[languageCode || 'en'];
};
